import { Route } from '@angular/router';
import { RouteGuardService } from 'src/app/services/route-guard.service';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { WeeklyScheduleListComponent } from '../../../../../pages/datasets/weekly-cycle-list/weekly-schedule-list.component';
import { WeeklyScheduleEditComponent } from '../../../../../pages/datasets/weekly-cycle-list/weekly-cycle-edit/weekly-schedule-edit.component';

export const weeklySchedules: Route = {
  path: 'weekly-schedules-list',
  title: 'nav.weeklySchedule',
  data: {
    breadcrumb: 'nav.weeklySchedule',
    icon: SbIcons.clock,
    id: RoutingID.weeklySchedule,
  },
  children: [
    {
      path: '',
      component: WeeklyScheduleListComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'weeklySchedule-edit/:weeklyScheduleID',
      title: 'nav.weeklySchedule.edit',
      data: {
        breadcrumb: 'nav.weeklySchedule.edit',
        icon: SbIcons.edit,
        id: RoutingID.weeklyScheduleEdit,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: WeeklyScheduleEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'weeklySchedule-create',
      title: 'nav.weeklySchedule.create',
      data: {
        breadcrumb: 'nav.weeklySchedule.create',
        icon: SbIcons.plus,
        id: RoutingID.weeklyScheduleCreate,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: WeeklyScheduleEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
